import i18n from '../language/index'
//edit_type表示这个挂件新增后，应该是出现编辑框，还是样式选择，还是什么都不显示
//btn_list  每个挂件可设置项目，index上面的按钮

/*
 * commonly: 常用模块
 * basics: 基础模块
 * interaction: 互动模块
 * senior: 高级模块
 * */
export const PendantList = [ // 
  {
    name: "basic_text_rich_type",
    title: 'base_module_config_1659',
    short_name: "text",
    icon_position: '-61px -550px',
    type: 'commonly', // 常用
    edit_type: "",
    isShow: true
  },
  // {
  //   name: "basic_text",
  //   title: "老文本",
  //   icon_position: '-61px -550px',
  //   type: 'commonly', // 常用
  //   edit_type: "",
  //   isShow: true
  // },
  {
    name: "basic_picture",
    title: 'view_download_index_180',
    short_name: "image",
    icon_position: '-135px -550px',
    type: 'commonly', // 常用
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_button",
    title: 'widgets_basic_article_list_edit_403',
    short_name: "bottom",
    icon_position: '0 0',
    type: 'commonly', //常用
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "basic_notice",
    title: 'base_module_config_1660',
    short_name: "bulletin",
    // icon_position: '-819px -626px',
    icon_position: '-1758px -551px',
    type: 'commonly', //常用
    edit_type: "",
    isShow: true
  },
  {
    name: 'basic_flod_text',
    title: 'widgets_basic_flod_text_edit_543',
    short_name: 'collapsed_text',
    icon_position: '0 0',
    type: 'commonly',
    edit_type: "",
    isShow: false,
    usePrivateIcon: true
  },
  {
    name: 'basic_flod_text_list',
    title: 'widgets_basic_flod_text_edit_543',
    short_name: 'collapsed_text',
    icon_position: '0 0',
    type: 'commonly',
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: 'basic_rich_text',
    title: i18n.t('base_module_config_1661'),
    short_name: 'graphic_display',
    icon_position: '-302px -550px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_list_photos",
    title: i18n.t('base_module_config_1662'),
    short_name: "list_multi-image",
    icon_position: '-383px -553px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_banner",
    title: i18n.t('widgets_basic_banner_edit_432'),
    short_name: "carousel_Multi-image",
    icon_position: '-465px -551px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: 'basic_article_list',
    title: i18n.t('widgets_basic_article_list_edit_366'),
    short_name: 'article_list',
    icon_position: '-552px -550px',
    type: 'basics', // 常用
    edit_type: '',
    isShow: true
  },
  {
    name: "basic_atlas_catalog",
    title: i18n.t('widgets_basic_atlas_catalog_edit_425'),
    short_name: "catalogue",
    icon_position: '-639px -550px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_product_display",
    title: i18n.t('base_module_config_1663'),
    short_name: "product_list",
    icon_position: '-722px -550px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_video",
    title: i18n.t('base_module_config_1664'),
    short_name: "video",
    icon_position: '-811px -549px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_crumbs",
    title: i18n.t('widgets_basic_crumbs_edit_490'),
    short_name: "position",
    icon_position: '-811px -550px',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_icon_combination",
    title: i18n.t('widgets_basic_icon_combination_edit_576'),
    short_name: "icon_text",
    icon_position: '0 0',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "basic_job",
    title: i18n.t('widgets_basic_job_edit_592'),
    icon_position: '0 0',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true,
    isOnlyDomestic: true,
    usePrivateIcon: true
  },
  {
    name: "basic_picture_text_swiper",
    title: i18n.t('base_module_config_1665'),
    short_name: "graphic_carousel",
    icon_position: '0 0',
    type: 'basics', // 基础模块
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: 'basic_development_history',
    title: i18n.t('widgets_basic_development_history_components_my_historys_index_492'),
    short_name: 'development_path',
    icon_position: '0 0',
    type: 'basics', // 常用
    edit_type: '',
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "basic_nleavemessage",
    title: i18n.t('base_module_config_1666'),
    short_name: "form",
    icon_position: '-950px -550px',
    type: 'interaction', //互动
    edit_type: "",
    isShow: true
  },
  {
    name: "basic_searchs",
    title: 'base_module_config_1667',
    short_name: "search",
    icon_position: '-1200px -550px',
    type: 'interaction', //互动
    edit_type: "",
    isShow: true
  },
  /* {
    name: "basic_floating_frame",
    title: "浮框",
    icon_position: '0px 0px',
    type: 'interaction', //互动
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  }, */
 /*  {
    name: "basic_login",
    title: "登录",
    icon_position: '0px 0px',
    type: 'interaction', //互动
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  }, */
  {
    name: 'basic_classification',
    title: 'widgets_basic_article_info_edit_348',
    short_name: 'classification',
    icon_position: '-1279px -550px',
    type: 'senior', // 高级
    edit_type: "",
    isShow: true
  },
  // {
  //   name: 'basic_article_classification',
  //   title: '文章分类',
  //   icon_position: '-1685px -550px',
  //   type: 'senior', // 高级
  //   edit_type: "",
  //   isShow: true
  // },
  // {
  //   name: 'basic_product_classification',
  //   title: '产品分类',
  //   icon_position: '-1279px -550px',
  //   type: 'senior', // 高级
  //   edit_type: "",
  //   isShow: true
  // },
  // {
  //   name: 'basic_map',
  //   title: '在线地图',
  //   short_name: 'map',
  //   icon_position: '-1366px -550px',
  //   type: 'senior', // 高级
  //   edit_type: "",
  //   isShow: true
  // },
  {
    name: 'basic_download',
    title: 'widgets_basic_download_edit_501',
    short_name: 'file_download',
    icon_position: '-1453px -550px',
    type: 'senior', // 常用
    edit_type: "",
    isShow: true
  },
  {
    name: 'basic_embed_page',
    title: i18n.t('widgets_basic_embed_page_edit_517'),
    short_name: 'embed_page',
    icon_position: '-1536px -550px',
    type: 'senior', // 高级
    edit_type: "",
    isShow: true
  },
  {
    name: 'basic_plugin_code',
    title: i18n.t('base_module_config_1668'),
    short_name: 'plugin_code',
    icon_position: '-1608px -550px',
    type: 'senior', // 高级
    edit_type: "",
    isShow: true
  },
  {
    name: 'basic_magic_number',
    title: i18n.t('base_module_config_1669'),
    short_name: 'dynamic_numbers',
    icon_position: '0 0',
    type: 'senior', // 高级
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: 'basic_progress',
    title: i18n.t('base_module_config_1670'),
    short_name: 'progress_bar',
    icon_position: '0 0',
    type: 'senior', // 高级
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "layout_row",
    title: i18n.t('base_module_config_1671'),
    short_name: "column_layout",
    icon_position: '0 0',
    type: 'layout',
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "basic_row_tab",
    title: i18n.t('base_module_config_1672'),
    short_name: "horizontal_layout",
    icon_position: '0 0',
    type: 'layout',
    edit_type: "",
    isShow: true,
    usePrivateIcon: true
  },
  {
    name: "basic_video_display",
    title: i18n.t('router_default_77'),
    icon_position: '-302px -550px',
    type: 'senior',
    edit_type: "",
    isShow: false
  },
  {
    name: "basic_download_display",
    title: i18n.t('router_default_81'),
    icon_position: '-302px -550px',
    type: 'senior',
    edit_type: "",
    isShow: false
  },
  // {
  //   name: "basic_member_register",
  //   title: "注册",
  //   icon_position: '-302px -550px',
  //   type: 'senior',
  //   edit_type: "",
  //   isShow: true
  // },
  // {
  //   name: "basic_member_center",
  //   title: "会员中心",
  //   icon_position: '-302px -550px',
  //   type: 'senior',
  //   edit_type: "",
  //   isShow: true
  // }
];


//数组转成对象
let PObj = {};
PendantList.map(item => {
  PObj[item.name] = {};
  for (let key in item) {
    PObj[item.name][key] = item[key];
  }
});


export const PendantObj = PObj;



// WEBPACK FOOTER //
// ./src/base/module_config.js